import styled from "styled-components";

export const BannerContainer = styled.div.attrs({})`
  position: relative;
  aspect-ratio: 94 / 32;
  background: url(${props => props.bgImage}) center/cover no-repeat;
  display: flex;
  align-items: center;
  transition: background-image 0.8s ease-in-out;
  flex: 1;
  @media (max-width: 718px) {
    aspect-ratio: 16 / 14;
    
    background-size: cover;
  }
`;

export const PlayedVideos = styled.video.attrs({
})`            
  width: 100%;
`;

export const Container = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Content = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0px 16px 16px 16px;
`;

export const Title = styled.div.attrs({})`
  color: ${p => p.theme.palette.colors.black};
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
`;

export const OptionsIcon = styled.div.attrs({})`
  padding: 7px 6px;
  background: ${p => p.theme.palette.colors.lightBlue};
  border-radius: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
